import { Image } from '@chakra-ui/react'

interface SidebarIconProps {
  icon: string
}

export const SidebarIcon = ({ icon }: SidebarIconProps) => {
  return <Image src={icon} w="10" />
}
